<!-- =========================================================================================
  File Name: DeviceCategorySidebar.vue
  Description: Category - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<i18n src="@/locales/modules/RoleTranslate.json"></i18n>

<template>
	<el-dialog
		class="custom-dialog"
		:title="$t('RolesManagement')"
		:visible.sync="isSidebarActiveLocal"
		:closed="() => $store.dispatch('rolesManagement/toggleRoleCategorySideBar', { status: false })"
	>
		<PerfectScrollbar ref="formScrollBar" class="scroll-area--data-list" :settings="settings">
			<div class="" id="list-employees">
				<div slot="header" class="flex flex-grow justify-end">
					<div slot="header" class="flex flex-grow justify-end bg-gray-7 p-6">
						<vs-input size="large" class="input-search mr-3 flex-1" icon="search" :placeholder="$t('Actions.Search')" v-model="searchText" />
						<vs-button v-if="mixinIsCanCreateUserRole" type="filled" class="w-auto sm:w-1/4 font-bold" @click="addNewData">{{ $t("Actions.AddNew") }}</vs-button>
					</div>
				</div>
				<div class="p-6 roles-sidebar">
					<vs-table class="stack-table" ref="table" :sst="true" :data="roles">
						<template slot-scope="{ data }">
							<tbody>
								<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
									<vs-collapse class="">
										<vs-collapse-item icon-pack="nucleo" icon-arrow="nucleo-right-arrow text-gray-4">
											<div slot="header" class="flex justify-between w-full p-0">
												<p class="text-black text-base">{{ tr.name }}</p>
												<div class="mr-8 ">
													<RoleContextMenu :role="tr" type="vertical" @onClickEdit="editData" @onClickDelete="showDeleteConfirm" @onClickManageTitle="handleManageTitle" />
												</div>
											</div>
											<div class="px-6">
												<vs-row v-for="title in tr.titles" :key="title.id" class="mb-6">
													<vs-col vs-w="7" vs-xs="12">
														<p class="text-base text-black">{{ title.name }}</p>
													</vs-col>
													<vs-col vs-w="5" vs-xs="12">
														<p class="text-base text-black">{{ title.department && title.department.name }}</p>
													</vs-col>
												</vs-row>
											</div>
										</vs-collapse-item>
									</vs-collapse>
								</vs-tr>
							</tbody>
						</template>
					</vs-table>
					<CbsPagination class="sm:justify-end mt-3 mr-3" v-if="totalPages > 0" :total="totalPages" v-model="currentx" />
				</div>
			</div>
		</PerfectScrollbar>

		<popup-create-or-update-roles-item :isPopupActive="isPopupActive" @closePopup="toggleCategoryPopup" :data="popupData" />
		<TitlesByRoleDialog v-if="isTitlesRoleActive" :role="titlesRoleData" :isSidebarActive="isTitlesRoleActive" @closeSidebar="toggleTitlesRoleSidebar" @onUpdateTitleSuccess="getListRoles" />
	</el-dialog>
</template>

<script>
import { userRolePermissions, getUserPermissions } from "@/mixins/mixins.js";

import PopupCreateOrUpdateRolesItem from "./PopupCreateOrUpdateRolesItem.vue";
import "vue-tree-halower/dist/halower-tree.min.css";
import RoleContextMenu from "./RoleContextMenu.vue";
import TitlesByRoleDialog from "./TitlesByRoleDialog.vue";
import { cloneDeep } from "lodash";
export default {
	mixins: [getUserPermissions(userRolePermissions)],
	components: {
		PopupCreateOrUpdateRolesItem,
		RoleContextMenu,
		TitlesByRoleDialog
	},
	props: {
		isSidebarActive: {
			type: Boolean,
			required: true
		}
	},
	data() {
		return {
			isPopupActive: false,

			popupData: {},
			treeDataKey: 0,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			},

			selected: [],
			currentx: 1,
			searchText: "",
			isTitlesRoleActive: false,
			titlesRoleData: null
		};
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			}
		},
		totalPages() {
			return Math.ceil(this.$store.state.rolesManagement.total / this.$store.state.rolesManagement.limitPerPage);
		},
		roles() {
			return (
				this.$store.state.rolesManagement.roles.filter(item => {
					return this.hanldeSearchRoles(item);
				}) || []
			);
		}
	},
	methods: {
		async getListRoles(isRefetch = false) {
			try {
				this.$vs.loading();

				const queryOptions = {
					limit: this.$store.state.rolesManagement.limitPerPage,
					page: this.currentx
				};
				if (isRefetch) {
					queryOptions.fetchPolicy = "no-cache";
				}

				// Fetch ROLES
				await this.$store.dispatch("rolesManagement/fetchRoles", queryOptions);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		toggleCategoryPopup(val = false) {
			this.isPopupActive = val;
		},
		addNewData() {
			this.popupData = {};
			this.toggleCategoryPopup(true);
		},
		editData(category) {
			try {
				this.popupData = category || {};
				this.toggleCategoryPopup(true);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			}
		},
		showDeleteConfirm(role) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				accept: () => this.deleteData(role.id),
				title: this.$t("Actions.Confirm"),
				acceptText: this.$t("Actions.Agree"),
				text: this.$t("Notify.DeleteConfirm"),
				cancelText: this.$t("Actions.Cancel")
			});
		},
		async deleteData(id) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("rolesManagement/deleteRole", { id: id });
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t("DeleteRolesSuccessful")
					}
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		hanldeSearchRoles(item) {
			return this.$helper.nonAccentVietnamese(item.name).includes(this.$helper.nonAccentVietnamese(this.searchText.trim()));
		},
		handleManageTitle(role) {
			this.titlesRoleData = cloneDeep(role);
			this.toggleTitlesRoleSidebar(true);
		},
		toggleTitlesRoleSidebar(val) {
			this.isTitlesRoleActive = val;
		}
	},

	created() {
		this.$store.subscribe(mutaion => {
			if (mutaion.type === "rolesManagement/SET_ROLE_CATEGORY_SIDEBAR_STATUS" && mutaion.payload) {
				this.getListRoles();
			}
		});
		this.$store.dispatch("rolesManagement/fetchModuleRoles");
	},
	watch: {
		currentx() {
			this.getListRoles();
		}
	}
};
</script>
<style lang="scss">
.roles-sidebar {
	.vs-collapse.default {
		padding: 0;
		.open-item .vs-collapse-item--icon-header {
			transform: translate(-50%, -50%) rotate(90deg) !important;
		}
	}
}
</style>
